import { IconProps } from '@/components/Icon';

export const IconCheckmark = ({ width = 16, height = 16, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 16 16' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path d='M3 8.5L7 12.5L13 3.5' stroke={color} strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
    </svg>
  );
};
